import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { SingleColumnLayout } from '../_layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { H2 } from '../../designSystem/typography/Heading';
import { PublicPageWrapper } from '../_pageWrappers/PublicPageWrapper';

export default function ErrorPage(): JSX.Element 
{
    const urlQuerySegment = useLocation().search;
    const message = new URLSearchParams(urlQuerySegment).get('message');

    return (
        <PublicPageWrapper>
            <PageHeader narrow headerText="Der opstod en fejl" />
            <SingleColumnLayout narrow>
                <>
                    {message 
                        ? <div dangerouslySetInnerHTML={{__html:message}} /> 
                        :
                        <>
                            <H2>Hov, det var ikke godt ....</H2>
                            <p>
                                Det ser ud til at der opstod en fejl.<br />
                                <br />
                                Vi vil blive glade hvis du vil skrive eller ringe til os,
                                så vi kan få rettet den i en fart.<br />
                                <br />
                                Mvh. AMORG
                            </p>
                        </>
                    }
                </>
            </SingleColumnLayout>
        </PublicPageWrapper>

    );
}